import {Stack, Typography} from "@mui/material";
import React from "react";
import LanguageHandler from "../translations/LanguageHandler";

const Services = () => {
    return (
        <Stack direction="column" padding="20px">
            <Typography variant="h4">
                {LanguageHandler.getTranslatedText("TRIPS_COUNTRY")}
            </Typography>
            <Typography variant="body1" padding="10px 0">
                {LanguageHandler.getTranslatedText("TRIPS_COUNTRY_DESCRIPTION")}
            </Typography>
            <Typography variant="h4">
                {LanguageHandler.getTranslatedText("TRIPS_OUTSIDE")}
            </Typography>
            <Typography variant="body1" padding="10px 0">
                {LanguageHandler.getTranslatedText("TRIPS_OUTSIDE_DESCRIPTION")}
            </Typography>
            <Typography variant="h4">
                {LanguageHandler.getTranslatedText("STUDENT_CAMPS")}
            </Typography>
            <Typography variant="body1" padding="10px 0">
                {LanguageHandler.getTranslatedText("STUDENT_CAMPS_DESCRIPTION")}
            </Typography>
        </Stack>
    )
}

export default Services;